import React, { useState, useEffect } from 'react';
import axios from 'axios';

const UserSelect = ({ value, onChange }) => {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get('/api/users');
        setUsers(response.data);
        setError(null);
      } catch (err) {
        setError('Error fetching users. Please try again later.');
        console.error('Error fetching users:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUsers();
  }, []);

  if (isLoading) {
    return (
      <select className="form-control" disabled>
        <option>
          Loading users...
        </option>
      </select>
    );
  }

  if (error) {
    return (
      <div className="has-error">
        <select className="form-control is-invalid" disabled>
          <option>{error}</option>
        </select>
        <div className="invalid-feedback">
          {error}
        </div>
      </div>
    );
  }

  return (
    <select
      className="form-control"
      value={value || ''}
      onChange={onChange}
      aria-label="Select user"
    >
      <option value="">Select Assignee</option>
      {users.map((user) => (
        <option key={user.id} value={user.id}>
          {user.name}
        </option>
      ))}
    </select>
  );
};

export default UserSelect;